// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"bb508c85","265":"9a60f773","743":"7f9363a7","787":"078c4857","926":"176e781a","968":"4b6871c0"}[chunkId] + ".chunk.js";
};